'use client';

import { useEffect, useState } from 'react';
import { compareEnabledByDefault, getCompareConfig } from '@/hotdesk-ui/lib/compare/config';
import { DEFAULT_COMPARE_CONFIG } from '@/hotdesk-ui/lib/compare/constants';
import type { CompareConfig } from '@/hotdesk-ui/lib/compare/types';

/**
 * Compare remote config for client components. Starts from the defaults so the
 * first render matches the server, then swaps in the fetched values.
 */
export function useCompareConfig(initial?: CompareConfig): CompareConfig {
    const [config, setConfig] = useState<CompareConfig>(
        () => initial ?? { ...DEFAULT_COMPARE_CONFIG, enabled: compareEnabledByDefault() }
    );

    useEffect(() => {
        let cancelled = false;
        getCompareConfig().then((next) => {
            if (!cancelled) setConfig(next);
        });
        return () => {
            cancelled = true;
        };
    }, []);

    return config;
}

export default useCompareConfig;
